import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/common/Navbar/Navbar';
import HomePage from './components/pages/HomePage/HomePage';
import Search from './components/pages/Search/Search';
import Footer from './components/common/Footer/Footer';
import AuthPage from './components/auth/AuthPage/AuthPage';
import AccountSettings from './components/auth/AccountSettings/AccountSettings';
import { VerifyEmail, ResetPassword } from './components/auth/EmailFlows/EmailFlows';
import Contact from './components/pages/Contact/Contact';
import Middlemen from './components/pages/Search/Middlemen';
import Traders from './components/pages/Search/Traders';
import Binders from './components/pages/Binders/Binders';
import Requests from './components/pages/Requests/Requests';
import Trade from './components/trading/Trade/Trade';
import TradeHistory from './components/pages/TradeHistory/TradeHistory';
import Profile from './components/pages/Profile/Profile';
import PrivacyPolicy from './components/pages/Legal/PrivacyPolicy';
import TermsOfService from './components/pages/Legal/TermsOfService';
import CreditsLegal from './components/pages/Legal/CreditsLegal';
import Shipping from './components/pages/Shipping/Shipping';
import ShopDashboard from './components/pages/ShopDashboard/ShopDashboard';
import Admin from './components/pages/Admin/Admin';
import Store from './components/pages/Store/Store';
import Messages from './components/pages/Messages/Messages';
import { ThemeProvider } from './contexts/ThemeContext';
import { ImageSourceProvider } from './contexts/ImageSourceContext';

function App() {
  return (
    <ThemeProvider>
      <ImageSourceProvider>
        <div className="App">
          <Navbar />
          {/* One frame for every page: same width, same side padding,
              so headers and content line up across the whole site */}
          <main className="page-frame">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<Search />} />
            {/* Legacy route: superseded by the recommended traders view */}
            <Route path="/suggested" element={<Navigate to="/traders" replace />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/account" element={<AccountSettings />} />
            {/* Experience lives in Account Settings now */}
            <Route path="/experience" element={<Navigate to="/account?tab=experience" replace />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/contact" element={<Contact />} />
            {/* Legacy route: Match my binder merged into Find Traders */}
            <Route path="/matches" element={<Navigate to="/traders" replace />} />
            <Route path="/middlemen" element={<Middlemen />} />
            <Route path="/traders" element={<Traders />} />
            <Route path="/binders" element={<Binders />} />
            <Route path="/requests" element={<Requests />} />
            {/* Legacy route: the open-trades board is retired - card
                discovery lives on Search */}
            <Route path="/trade-browser" element={<Navigate to="/search" replace />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/trades/:tradeId/history" element={<TradeHistory />} />
            <Route path="/shipping/:tradeId" element={<Shipping />} />
            <Route path="/shop" element={<ShopDashboard />} />
            <Route path="/store/:shopId" element={<Store />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/credits" element={<CreditsLegal />} />
          </Routes>
          </main>
          <Footer />
        </div>
      </ImageSourceProvider>
    </ThemeProvider>
  );
}

export default App;
